// extracted by mini-css-extract-plugin
export default {"container":"hk-z","freeShip":"ik-z","privacy":"jk-z"};